import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '~/app/rootReducer';

import { INITIAL_FLEET_MAP_STATE } from './fleetMapSlice.constants';
import { FLEET_MAP_REDUCERS } from './fleetMapSlice.reducers';

const {
  reducerUpdateFleetMapFilters,
  reducerResetFleetMapFilters,
  reducerUpdateFleetMapSearch,
  reducerSetSelectedVehicle,
  reducerSetHoveredVehicle,
  reducerSetVehicleDetails,
  reducerResetHoverState,
  reducerSetCenterOnFleet,
} = FLEET_MAP_REDUCERS;

export const fleetMapSlice = createSlice({
  name: 'fleetMap',
  initialState: INITIAL_FLEET_MAP_STATE,
  reducers: {
    updateFleetMapFilters: reducerUpdateFleetMapFilters,
    resetFleetMapFilters: reducerResetFleetMapFilters,
    updateFleetMapSearch: reducerUpdateFleetMapSearch,
    setSelectedVehicle: reducerSetSelectedVehicle,
    setHoveredVehicle: reducerSetHoveredVehicle,
    setVehicleDetails: reducerSetVehicleDetails,
    resetHoverState: reducerResetHoverState,
    setCenterOnFleet: reducerSetCenterOnFleet,
  },
});

export const {
  updateFleetMapFilters,
  resetFleetMapFilters,
  updateFleetMapSearch,
  setSelectedVehicle,
  setHoveredVehicle,
  setVehicleDetails,
  resetHoverState,
  setCenterOnFleet,
} = fleetMapSlice.actions;

export const selectFleetMapState = (state: RootState) => state.fleetMap;

export const fleetMapReducer = fleetMapSlice.reducer;
